const intros = {
  'WRY': {
    title: '污染源在线监测平台',
    content: [
      '污染源在线监测系统，将自动监测设备与数采仪直连，利用数采仪进行数据计算与传输，实现对自动监测设备监测数据、工作参数、运行状态的“三同时”监控、具有工作状态和设备参数异常报警、设备参数与监测项目关联分析、远程抓拍取证、短信报警和设备远程反控等功能。',
      '系统能够有效切断修改设备工作参数等造假途径，及时发现、判断、响应和处理自动监控设备中出现的异常、造假等情形并固定证据，大大提升了污染源自动监测的数据质量和监管效率，可协助用户进行现场检查、分析、判断现场在线监测设备存在的各类不规范行为，为排污收费和总量减排提供准确的数据支撑，解决环保工作事多人少难度大的问题。'
    ]
  },
  'YYSAQ': {
    title: '饮用水安全在线监管系统',
    content: [
      '饮用水水质监测是一项长期、连续、系统地收集饮用水水质变化趋势的基础性工作，是健康危害因素监测的重要组成部分，是保障居民饮用水卫生安全的关键措施，意义重大。然而，目前水质检测的方法存在以下问题：',
      '由于净水水质中各因子浓度很低，常用传感器无法实现实时高精度检测。因此使用的方法为现场采样与实验室仪器分析相结合的离线检测方法，这样就造成检测周期长、不能实时出数据、人为报告作假等风险。这样的检测方法无法满足实时、在线、快速的水质检测要求，无法及时保障人们的饮水安全。另外，消耗的化学试剂存在二次污染，难以满足现代水质检测技术的要求，更无法满足绿色无污染检测技术的要求。因此，建立科学、规范、完善的饮用水在线监管体系，既是各级卫生部门的责任，也是各地政府高度关注的民生问题，更是贯彻落实科学发展观的任务与要求。',
      '为致力于践行“让国人喝上放心水”的使命，德润厚天开发了饮用水水质在线监管系统。该系统不仅能为卫生部门及时动态获取水质数据、监管水质安全提供技术手段，且有助于供水企业与水质监管机构实现快速监测、识别饮用水水质异常与污染，是建立饮用水水质监测预警体系，保障供水水质安全，为改善水质提供科学依据的有力工具。',
      '德润厚天开发的饮用水安全在线监管系统是一套应用于饮用水进水、过程处理、出水水质检测的实时在线监测系统，主要由饮用水水质表、软件平台、监控中心三部分组成。它利用全新一代检测单元，集中对饮用水的高锰酸盐指数（COD<sub class="size6">Mn</sub>）、浊度、溶解性总固体（TDS）、温度等水质参数进行一体化实时在线监控，将数据发送到监控中心服务器、手机、电脑等设备。 饮用水安全在线监管系统能实时监测水质数据、查询历史数据，同时为管理部门提供数据共享，通过远程平台展示水质信息。'
    ]
  },
  'YWSSZ': {
    title: '原位实时水质自动监测系统',
    content: [
      '德润厚天原位实时水质自动监测系统是保留浮标式水站的精华，省略浮标站的非主导功能，推出的监测响应速度快、投资费用少、维护量小、运行费用低、实用性更强的全新一代水质自动监测系统。',
      '采用光学、电化学水质分析仪投入水体，实时原位监视水质动态。一旦水质变化异常，第一时间发通知到管理人员手机。',
      '主要用于对饮用水源地、河道、湖泊、水库等地表水进行原位实时水质监控，对突发性污染事故的快速响应，对区域水质变化进行长时间特征分析，由于结构简单，费用低，适于链条式布点，实时掌握区域水质状况，是“河长”掌握本领域内水质状况的有效工具，是实施河流网格化监测实现数字河流的有效方法。'
    ]
  },
  'DR803C5': {
    title: 'DR-803C5执法专用采样器',
    content: [
      '本系统配合德润厚天研发的 DR-803C5执法专用水质自动采样器进行使用，主要用于环境执法和监测部门对污染源企业的排口进行抽查采样，方便环保部门对现场安装的水质自动采样器进行远程管理。系统具备操作简单，采样参数设置灵活多样，视频监控安全可靠的特点，是环保执法部门日常工作不可或缺的重要工具。',
    ]
  },
  'DR803C3': {
    title: '水质采样器系统',
    content: [
      '本系统配合德润厚天研发的 DR-803C3水质自动采样器进行使用，主要用于对污水检查井内水质采样，方便环境监测部门对现场安装的水质自动采样器进行远程管理。系统具备操作简单，设置灵活，预置参数自动采样的特点，适合井下长时间无人值守自动采样， 是环境监测部门、城建部门、排水公司、第三方检测机构检查井采样的重要工具。',
      '本系统配合德润厚天研发的低功耗型水质自动采样器进行使用，主要用于无市电供电的采样器，一般采用电池或太阳能进行供电，为了减少宝贵的电能的消耗，该系统与采样器进行联动，可实现设备超低功耗、超长待机。系统能够实现采样器工作模式、采样参数的远程设置、记录和状态的查询，使用便捷，是环境监测部门、城建部门、排水公司、第三方检测机构采样的重要工具。'
    ]
  },
  'samplerPlatform': {
    title: '水质自动采样器平台',
    content: [
      '德润厚天水质自动采样器平台是一种通用的采样器远程管理系统，该平台能够兼容德润厚天自主研发的多种类型采样器，系统通过无线网络与设备进行远程通讯，实现水质自动采样器的集中管理。通过平台可实现对设备的远程控制采样、留样等功能，同时可实时监测采样数据及历史记录。系统具备操作简单，设置灵活，预置参数自动采样的特点，是环境监测部门、第三方检测机构水质采样的重要工具。'
    ]
  },
  'samplerLowPower': {
    title: '水质自动采样器(低功耗型)',
    content: [
      '本系统配合德润厚天研发的低功耗型水质自动采样器进行使用，主要用于无市电供电的采样器，一般采用电池或太阳能进行供电，为了减少宝贵的电能的消耗，该系统与采样器进行联动，可实现设备超低功耗、超长待机。系统能够实现采样器工作模式、采样参数的远程设置、记录和状态的查询，使用便捷，是环境监测部门、城建部门、排水公司、第三方检测机构采样的重要工具。'
    ]
  },
  'DR103C5': {
    title: 'DR-103C5便携式水质综合分析仪系统',
    content: [
      'DR-103C5便携式水质综合分析仪系统软件是一套应用于地表水、地表水纳污口、污水排放口、农村黑臭水体等，以及污水处理厂或相关企业的各个处理环节等水质检测的实时在线监测系统，主要由DR-103C5便携式水质综合分析仪、软件平台两部分组成。',
      '水质综合分析仪采用智能多参数数字传感器，获取检测点准确的位置信息，可以投入直接河流、湖库、入海河流考核断面、污水处理厂各环节、排污企业外派口等现场直接对pH、电导率、溶解氧、温度、浊度、COD、氨氮、叶绿素等参数进行原位监测，实时、快速出测试结果，同时将监测数据发送到软件平台服务器、手机、电脑等设备。',
      'APP及软件平台能实时监测水质数据、查询历史数据，同时为水环境监测主管部门、第三方检测部门等提供数据共享，通过远程平台展示水质信息。'
    ]
  },
}

export default {
  intros
}


// WEBPACK FOOTER //
// ./src/assets/js/global_app_intro.js